/**
 * Scroll Listener workaround for iFrame on iOS 10+ (May 17 2018)
 *
 * The Width/Height of IFrame on iOS, whatever the values you set, will always have width/height
 * equal to width/height of the document, which gets rendered inside that iFrame. Furthermore,
 * the width/height of iFrame is calculated regarding the entire render tree, not its visible parts.
 *
 * This behavior brings tons of bugs and issues. One of those issues is solved by this workaround.
 *
 * Thus, since iFrame is always equal to document height, default scroll listener will not work,
 * because iFrame's window is not scrollable.
 *
 * This workaround introduces another approach. It dynamically calculates the scroll position of
 * iFrame basing on the scroll position of the first scrollable element which contains the iFrame.
 */

import { getClosestScrollableElement } from 'anodum';
import bowser from 'yola-bowser';
import eventListeners from './event-listeners';

const add = (liveDocument, handler) => {
  let scrollElement;

  if (bowser.ios) {
    scrollElement = getClosestScrollableElement(
      liveDocument.defaultView.frameElement.parentElement,
      false
    );
  } else {
    scrollElement = liveDocument;
  }

  eventListeners.add(scrollElement, 'scroll', handler);
};

export default {
  add,
};
